import * as Yup from 'yup';

export default Yup.object().shape({
  billingName: Yup.string().required('SCHEMA_ERRORS.FULL_NAME_REQUIRED')
});
